import React from 'react';

/**
 * The shell every full-page view sits in.
 *
 * The five content pages had four different max-widths — 768, 896, 1024 and
 * 1152px — so moving between the list and the dashboard visibly changed how
 * wide the content was, and the graph panel had none at all and ran the full
 * width of a 1920px monitor. There are two widths now and a rule for choosing:
 * the default reads well for cards and forms, and `wide` is for a page whose
 * content is genuinely tabular.
 *
 * The padding was wrong in two directions as well:
 *
 *   pt-20 md:pt-24 cleared a TopBar. TopBar has not been rendered for some
 *   time — it is not imported anywhere — so three pages opened with 80px of
 *   empty space above the title. The comments on those lines still said "safe
 *   padding for TopBar", which is how it survived.
 *
 *   pb-24 reserved room for the bottom nav, but .main-content already reserves
 *   exactly --bottom-nav-height for it, so pages inside it reserved the space
 *   twice. ProfileView renders outside .main-content and genuinely needs its
 *   own — that is what `standalone` is for, and it uses the token rather than
 *   a magic 24 so it tracks the home-indicator inset.
 */
const PageContainer = ({ wide = false, standalone = false, className = '', testId, children }) => (
  <div className="h-full w-full overflow-y-auto scroll-pane bg-gray-900" data-testid={testId}>
    <div
      className={`${wide ? 'max-w-6xl' : 'max-w-5xl'} mx-auto px-4 md:px-6 py-6 ${className}`}
      style={standalone ? { paddingBottom: 'calc(var(--bottom-nav-height) + 1.5rem)' } : undefined}
    >
      {children}
    </div>
  </div>
);

export default PageContainer;
